import axios from "axios"
import {ActionService, ApiCallService, apiRequest} from "@libs/ClientService"
import {IGroup, IUser} from "@backend/types"

export const userActions = new ActionService<IUser>("user")

class UserApiCalls extends ApiCallService<IUser> {

    constructor() {
        super("user")
    }

    approve = async (userId: string) => apiRequest<string>(axios.get(`${this.resourceUrl}/approve/${userId}`))

    currentUser = async () => apiRequest<IUser>(axios.get(`${this.resourceUrl}/me`))
    sendPasswordResetLink = async () => apiRequest<string>(axios.get(`${this.resourceUrl}/me/sendPasswordResetLink`))

    currentUserUpdate = async (data: any) => apiRequest<boolean>(axios.post(`${this.resourceUrl}/me`, data))

    currentUserPasswordUpdate = async (data: {
        currentPassword?: string,
        password: string
    }) => apiRequest<boolean>(axios.post(`${this.resourceUrl}/me/passwordUpdate`, data)) //
}

export const userApiCalls = new UserApiCalls()

export const groupApiCalls = new ApiCallService<IGroup>("group")